import { render } from "./TrainerData.vue?vue&type=template&id=1d7b530a&scoped=true"
import script from "./TrainerData.vue?vue&type=script&lang=js"
export * from "./TrainerData.vue?vue&type=script&lang=js"

import "./TrainerData.vue?vue&type=style&index=0&id=1d7b530a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7b530a"]])

export default __exports__